import { Card, Flex } from "antd";
import React from "react";
import api from "../../../api";
import { AppState } from "../../../store/appSlice";
import { useAppSelector } from "../../../store";
import Loader from "../../../components/Loader";

const AdminClientTypes = () => {
  const { field_Language } = useAppSelector(
    (data: { app: AppState }) => data.app
  );

  const { data: clientTypes, isLoading } =
    api.useGetClientTypesQuery(undefined);

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Flex gap={30} wrap="wrap" justify="space-evenly">
        {clientTypes &&
          clientTypes?.map((item, index) => (
            <Card
              key={index}
              hoverable
              style={{
                maxWidth: "300px",
                width: "100vw",
                display: "grid",
                placeItems: "center",
                height: "100%",
              }}
            >
              {item.translations?.[field_Language]?.name}
            </Card>
          ))}
      </Flex>
    </>
  );
};

export default AdminClientTypes;
